import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useFeatureAccess } from '../context/FeatureAccessContext';
import { AdBanner, AdLayout } from './AdBanner';

interface ConditionalAdProps {
    position: string;
    className?: string;
    layout?: AdLayout;
}

export const ConditionalAd: React.FC<ConditionalAdProps> = ({ position, className, layout }) => {
    const { user } = useAuth();
    const { subscription } = useFeatureAccess();

    // Show ads for the specific position provided (e.g., DASHBOARD, SIDEBAR)
    return <AdBanner position={position} className={className} layout={layout} />;
};
